import React, { FC } from 'react';
import { VideoPlayer } from '../../../../components/common';
import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';
import { useVideoPreviews } from '../../../../utils/media-manager-sdk/hooks';
import { IOuter } from '../ItemDemonstration.types';

const playerConfig = { hideOverlay: true };

export const Video: FC<IOuter> = ({ item, className, saveRef }) => (
  <div className={className} data-hook="expanded-view-video-demonstration" ref={saveRef}>
    <VideoPlayer autoplay src={useVideoPreviews(item as MediaManagerSDKFile)} fillAllSpace config={playerConfig} />
  </div>
);
